import React, { useEffect, useState } from "react";
import logo from "../assets/img/logoN.png";

export default function PageLoader({ onFinish }) {
  const [progress, setProgress] = useState(0);
  const [stage, setStage] = useState("entering");

  useEffect(() => {
    const timer = setTimeout(() => setStage("loading"), 50);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (stage !== "loading") return;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setStage("exiting");
            setTimeout(() => {
              if (onFinish) onFinish();
            }, 800);
          }, 500);
          return 100;
        }

        let increment = Math.random() * 3 + 1;
        if (prev > 70) increment = Math.random() * 5 + 2;

        return Math.min(prev + increment, 100);
      });
    }, 80);

    return () => clearInterval(interval);
  }, [stage, onFinish]);

  const isExiting = stage === "exiting";
  const isEntering = stage === "entering";

  return (
    <>
      <div
        style={{
          ...styles.container,
          opacity: isExiting ? 0 : 1,
          transform: isExiting ? "scale(1.05)" : "scale(1)",
          pointerEvents: isExiting ? "none" : "auto",
        }}
      >
        <div style={styles.ambientLight} />

        <div
          style={{
            ...styles.contentWrapper,
            opacity: isEntering ? 0 : 1,
            transform: isEntering ? "translateY(20px)" : "translateY(0)",
          }}
        >
          <div style={styles.imageFillContainer}>
            {/* 1. Logo Base (Tenue) */}
            <img src={logo} alt="Cargando base" style={styles.logoGhost} />

            {/* 2. Logo Lleno (Se revela hacia arriba con resplandor blanco) */}
            <img
              src={logo}
              alt="Cargando progreso"
              style={{
                ...styles.logoFilled,

                clipPath: `inset(${100 - progress}% -50px -50px -50px)`,
              }}
            />
          </div>

          <div style={styles.textContainer}>
            <span style={styles.loadingText}>CARGANDO PÁGINA...</span>
            <span style={styles.percentageText}>{Math.floor(progress)}%</span>
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes pulseText {
            0%, 100% { opacity: 0.5; }
            50% { opacity: 1; text-shadow: 0 0 8px rgba(255,255,255,0.5); }
          }
          @keyframes floatSlow {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-8px); }
          }
        `}
      </style>
    </>
  );
}

const styles = {
  container: {
    position: "fixed",
    inset: 0,
    backgroundColor: "#030712",
    backgroundImage:
      "radial-gradient(circle at 50% 50%, #0a1945 0%, #030712 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    transition: "opacity 0.8s ease-in-out, transform 0.8s ease-in-out",
  },
  ambientLight: {
    position: "absolute",
    width: "50vw",
    height: "50vw",
    background:
      "radial-gradient(circle, rgba(255, 255, 255, 0.03) 0%, transparent 60%)",
    filter: "blur(50px)",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 2,
    transition:
      "opacity 1s ease-out, transform 1s cubic-bezier(0.2, 0.8, 0.2, 1)",
    animation: "floatSlow 5s ease-in-out infinite",
  },
  imageFillContainer: {
    position: "relative",
    width: "clamp(150px, 30vw, 250px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "40px",
  },
  logoGhost: {
    width: "100%",
    display: "block",
    opacity: 0.15, // Mantiene sus colores originales, solo que muy transparente
  },
  logoFilled: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
    filter:
      "drop-shadow(0 0 10px rgba(255, 255, 255, 1)) drop-shadow(0 0 20px rgba(255, 255, 255, 0.5))",
    transition: "clip-path 0.1s linear",
    zIndex: 2,
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  loadingText: {
    color: "#ffffff",
    fontSize: "0.85rem",
    fontWeight: "500",
    letterSpacing: "4px",
    animation: "pulseText 2s infinite",
    opacity: 0.8,
  },
  percentageText: {
    color: "#ffffff",
    fontSize: "1.5rem",
    fontWeight: "700",
    letterSpacing: "2px",
    fontVariantNumeric: "tabular-nums",
  },
};
